export default __webpack_public_path__ + "static/media/certifiedJS.c84488dd.png";